import { observable, makeAutoObservable } from 'mobx';
import { TypeId } from 'src_common/common/websocket2/type';

export class MarketsListState {
    @observable opened: TypeId.MarketId | null = null;

    setMarket = (marketId: TypeId.MarketId): void => {
        this.opened = marketId;
    };

    closeMarket = (): void => {
        this.opened = null;
    };

    constructor() {
        makeAutoObservable(this);
    }
}
